module.exports = __webpack_public_path__ + "images/blank-file.5ae65e71.svg";